export const socialButtonTypes = ['facebook', 'google', 'apple'] as const
export type SocialButtonType = (typeof socialButtonTypes)[number]

export type SocialButtonArgs = {
  type: SocialButtonType
}
